<template>
  <div class="cta-box">
    <div class="cta-box__image"></div>
    <div class="cta-box__main">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.cta-box {
  padding: 20px 40px;
  border: 1px solid $black;

  @include mq($xl) {
    padding: 40px 80px;
  }

  &__main {
    max-width: 650px;
  }
}
</style>
